<template>
 <div class="mb-4">
    <!-- List of emails -->
   <div v-if="email.length > 0">
    <div v-for="(res,index) in email" :key="index" class="listnotification">
       <span>EMAIL</span>{{res}}<a @click="remove('email',index)">REMOVE</a>
    </div>
    </div>
    <!-- List of mobile phones -->
   <div v-if="sms.length > 0">
    <div v-for="(res,index) in sms" :key="index"  class="listnotification">
       <span>SMS</span>{{mobilePhone(res)}}<a @click="remove('sms',index)">REMOVE</a>
    </div>
    </div>
   </div>
</template>
   <script>
       export default {
         name: "EmailAndPhoneList",
         components: {},
         props:{
           email:Array,
           sms:Array
         },
         data() {
           return {}
         },
         methods:{
            mobilePhone(val) {
               let num=null;
               if(val) {
                  num = val.substring(val.length - 10);
               }
               return num.length == 10 ? num.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : null;
            },
            remove(val,index) {
                let obj = {val : val , index : index}
                this.$emit('remove',obj);
            },
            

         },
       }
     </script>

   <style scoped>
   .listnotification {
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;
    align-items: center;
    width: 460px;
    max-width: 100%;
}
.listnotification span {
    background: #e2e2e2;
    width: 70px;
    text-align: center;
    border-radius: 8px;
    margin-right: 10px;
    font-size: 14px;
    height: 25px;
    text-align: center;
    line-height: 25px;
}
.listnotification a {
    margin-left: auto;
    color: #7b7b7b;
    text-decoration: underline !important;
}
   </style>
   
     